import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { toDollars } from "../../../../helpers/currencies";
import { CRMAppLocationIdentifier, FaqProps } from "../../../../types/Faq";

const DossierSavingsTotals = ({
  gstSavings,
  incomeTaxSavings,
  faqs,
  faqAppLocationIdentifiers,
}: {
  gstSavings: number | undefined;
  incomeTaxSavings: number | undefined;
  faqs: FaqProps;
  faqAppLocationIdentifiers: {
    gstSavings: CRMAppLocationIdentifier;
    incomeTaxSavings: CRMAppLocationIdentifier;
    totalSavings: CRMAppLocationIdentifier;
  };
}) => {
  const totalSavings =
    gstSavings !== undefined && incomeTaxSavings !== undefined
      ? gstSavings + incomeTaxSavings
      : undefined;

  const renderAppLocation = faqs.renderAppLocation;

  return (
    <Stack>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 8,
          alignItems: "center",
        }}
      >
        {renderAppLocation(
          faqAppLocationIdentifiers.gstSavings,
          <Typography variant="titleMedium">
            GST Saved on Running Costs
          </Typography>
        )}
        {renderAppLocation(
          faqAppLocationIdentifiers.gstSavings,
          <Box
            sx={{
              p: 0.5,
              backgroundColor: "primary.main",
              width: "6rem",
              height: "2rem",
            }}
          >
            <Typography
              variant="titleMedium"
              color="onPrimary.main"
              sx={{ whiteSpace: "nowrap", px: 1, textAlign: "right" }}
            >
              {gstSavings !== undefined ? toDollars(gstSavings, 0) : ""}
            </Typography>
          </Box>
        )}
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="titleMedium" alignSelf="end">
          +
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 8,
            alignItems: "center",
          }}
        >
          {renderAppLocation(
            faqAppLocationIdentifiers.incomeTaxSavings,
            <Typography variant="titleMedium">Income Tax Saved</Typography>
          )}
          {renderAppLocation(
            faqAppLocationIdentifiers.incomeTaxSavings,
            <Box
              sx={{
                p: 0.5,
                backgroundColor: "primary.main",
                width: "6rem",
                height: "2rem",
              }}
            >
              <Typography
                variant="titleMedium"
                color="onPrimary.main"
                sx={{ whiteSpace: "nowrap", px: 1, textAlign: "right" }}
              >
                {incomeTaxSavings !== undefined
                  ? toDollars(incomeTaxSavings, 0)
                  : ""}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="titleMedium" alignSelf="end">
          =
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 3.5,
            alignItems: "center",
          }}
        >
          {renderAppLocation(
            faqAppLocationIdentifiers.totalSavings,
            <Typography variant="titleLarge">Total Savings</Typography>
          )}
          {renderAppLocation(
            faqAppLocationIdentifiers.totalSavings,
            <Box
              sx={{
                p: 0.5,
                backgroundColor: "secondary.main",
                height: "3.125rem",
                minWidth: "8.25rem",
              }}
            >
              <Typography
                variant="headlineMedium"
                color="onSecondary.main"
                sx={{ whiteSpace: "nowrap", px: 1, textAlign: "right" }}
              >
                {totalSavings !== undefined ? toDollars(totalSavings, 0) : ""}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Stack>
  );
};

export default DossierSavingsTotals;
